import React from "react";
import { useData } from "../hooks/useData";
import { PageHeader, DataTable, StatusBadge } from "../components/shared";
import { fmtDate } from "../lib/api";

export default function Audit() {
  const { data, loading } = useData("/audit-logs");
  const columns = [
    { key: "timestamp", header: "Date/Time", render: (r) => fmtDate(r.timestamp) + " " + new Date(r.timestamp).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) },
    { key: "user_name", header: "User", render: (r) => <div><p className="font-medium text-slate-800">{r.user_name}</p><p className="text-xs text-slate-400">{r.user_email}</p></div> },
    { key: "role", header: "Role" },
    { key: "action", header: "Action", render: (r) => <StatusBadge status={r.action} /> },
    { key: "module", header: "Module" },
    { key: "record_id", header: "Record", mono: true },
  ];
  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Immutable log of all system activities" />
      {!loading && <DataTable testid="audit-table" columns={columns} rows={data} exportName="audit-logs.csv" dense />}
    </div>
  );
}
